import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'form-session-time-slots',
  templateUrl: './form-session-time-slots.component.html',
  styleUrls: ['./form-session-time-slots.component.scss']
})
export class FormSessionTimeSlotsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
